import { createAction } from '@reduxjs/toolkit';
import { pubSub } from 'utils/pubSub';
/**
 * Creates a custom show modal action that returns a promise of the user actions
 * within the modal. For example, the user cancelling or confirming.
 *
 * @param type The action type.
 */
// This cannot be explicitly typed as the generic gets passed into the action
// creator function.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createShowModalAction(type) {
    const action = createAction(type);
    return Object.assign((payload) => (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(action(payload));
            pubSub.publish('showModal', {
                type: payload.modal.type,
                meta: { resolve, reject },
            });
        });
    }, { action });
}
